<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h3 style="text-align: center;font-family: Tangerine,serif;font-size: 60px;margin:20px">
        My Works</h3>
       <nav class="nav-justified">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="false">Projet 1</a>
          <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Projet 2</a>
          <a class="nav-item nav-link active" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="true">Projet 3</a>
          <a class="nav-item nav-link" id="nav-contact1-tab" data-toggle="tab" href="#nav-contact1" role="tab" aria-controls="nav-contact1" aria-selected="false">Projet 4</a>
          <a class="nav-item nav-link" id="nav-contact2-tab" data-toggle="tab" href="#nav-contact2" role="tab" aria-controls="nav-contac2" aria-selected="false">Projet 5</a>

        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <img src="./assets/images5/course.png" height="350px" alt="">
              </div>
              <div class="col-md-8" style="padding: 50px;text-align: center" >
                <h6 >Projet 1 :Web Application for HR Management inside our Faculty .</h6>
                <br>
                <hr>

                <ul>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                </ul>

              </div>
            </div>
          </div>


        </div>
        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
          <app-fifth-child></app-fifth-child>
        </div>
        <div class="tab-pane fade  show active" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
          <div class="container">
            <div class="row">
              <div class="col-md-4" style="padding: 5px">
                <img src="./assets/images5/offer.png" height="350px" alt="">
              </div>
              <div class="col-md-8" style="padding: 50px;text-align: center" >
                <h6 >Projet 1 :Web Application for HR Management inside our Faculty .</h6>
                <br>
                <hr>

                <ul>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                </ul>

              </div>
            </div>
          </div>

        </div>
        <div class="tab-pane fade" id="nav-contact1" role="tabpanel" aria-labelledby="nav-contact1-tab">
          <app-fifth-child></app-fifth-child>
        </div>
        <div class="tab-pane fade" id="nav-contact2" role="tabpanel" aria-labelledby="nav-contact2-tab">
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <img src="./assets/images5/contact.png" height="350px" alt="">
              </div>
              <div class="col-md-8" style="padding: 50px;text-align: center" >
                <h6 >Projet 1 :Web Application for HR Management inside our Faculty .</h6>
                <br>
                <hr>

                <ul>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                  <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
                </ul>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
